import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import { Translate } from "utils";

import styles from "./Unit.css";

const { t } = new Translate();

const Unit = ({ isBlack, unit, value }) => (
  <div className={cx(styles.root, { [styles.black]: isBlack })}>
    {t(`units.${unit}`, value && parseInt(value, 10))}
  </div>
);

Unit.propTypes = {
  unit: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isBlack: PropTypes.bool,
};

export default Unit;
